/**
 * HumanAI logomark + optional "HumanAI" wordmark.
 *
 *   <Logo />                         → mark only
 *   <Logo wordmark />                → mark + "HumanAI" (AI in cyan)
 *   <Logo white />                   → mark turned solid white (for gradient bg)
 *   <Logo wordmark sub="PayPilot" /> → adds a small product label under the wordmark
 *
 * The mark is a transparent PNG in /public; `white` flips it to a white
 * silhouette via filter so it reads on the brand gradient panel.
 */
interface Props {
  /** Tailwind height class for the mark, e.g. "h-8" (default). */
  size?: string;
  white?: boolean;
  wordmark?: boolean;
  /** Small product/sub label rendered under the wordmark. */
  sub?: string;
  className?: string;
}

export function Logo({ size = 'h-8', white = false, wordmark = false, sub, className = '' }: Props) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/humanai-logo.png"
        alt="HumanAI"
        className={`${size} w-auto object-contain ${white ? '[filter:brightness(0)_invert(1)]' : ''}`}
      />
      {wordmark && (
        <span className="leading-none">
          <span className={`font-display font-semibold text-lg ${white ? 'text-white' : 'text-gray-900'}`}>
            Human<span className={white ? 'text-white' : 'text-cyan-500'}>AI</span>
          </span>
          {sub && (
            <span className={`block text-xs mt-0.5 ${white ? 'text-white/80' : 'text-gray-400'}`}>{sub}</span>
          )}
        </span>
      )}
    </span>
  );
}
